var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_attachment_icon",
    "data-name": "remove attachment icon",
    transform: "translate(-1121 -639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_field_icon",
    "data-name": "close field icon",
    transform: "translate(645 89)",
    opacity: 0.375
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    transform: "translate(477 551)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 7,
    y2: 7,
    transform: "translate(482.5 556.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y1: 7,
    x2: 7,
    transform: "translate(482.5 556.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "close_field_icon-2",
    "data-name": "close field icon",
    transform: "translate(644 88)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-2",
    "data-name": "Ellipse 41",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(477 551)",
    fill: "#c44538"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45-2",
    "data-name": "Line 45",
    x2: 7,
    y2: 7,
    transform: "translate(482.5 556.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46-2",
    "data-name": "Line 46",
    y1: 7,
    x2: 7,
    transform: "translate(482.5 556.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.737397023c6ca6a1bce219a35f0cb8d9.svg";
export { ForwardRef as ReactComponent };